module.exports = __webpack_public_path__ + "static/media/2.a03867b2.png";